import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class NewPostInTagNotification extends Notification {
  icon() {
    return 'fas fa-user-tag';
  }

  href() {
    const subject = this.attrs.notification.subject();
    const data = this.attrs.notification.content() || {};
    return app.route.discussion(subject, data.postNumber);
  }

  content() {
    const notification = this.attrs.notification;
    const subject = notification.subject();
    const tagName = notification.attribute('subjectTagName');
    const postExcerpt = notification.attribute('subjectPostExcerpt');
    const title = subject ? subject.title() : '';
    const displayTitle = tagName ? `${title} [${tagName}]` : title;
    const text = app.translator.trans('florcarioca-rsvp.forum.notifications.new_post_in_tag_text', {
      user: notification.fromUser(),
      discussion_title: displayTitle,
    });
    return postExcerpt ? [text, ` : ${postExcerpt}`] : text;
  }

  excerpt() {
    return null;
  }
}
